

export enum ActivityUpdateType {
  INSPECTION_STARTED = 'InspectionStarted',
  IMAGE = 'Image',
  IMAGE_UPLOAD_COMPLETED = 'ImageUploadCompleted',
  INSPECTION = 'Inspection',
  INSPECTION_UPDATING = 'InspectionUpdating',
}
